// Runtime-injected client config.
//
// On the server (SSR, API routes, getServerSideProps, getInitialProps), config
// values come from `process.env.*` directly — populated at task launch by ECS
// `container_env`. No NEXT_PUBLIC_ prefix on the server.
//
// On the client, config values come from `window.__CONFIG__`, which `_document.js`
// injects as an inline `<script>` block at SSR render time so the values land in
// the HTML response before any React bundle runs.

const CLIENT_KEYS = [
  'APP_ENV',
  'APP_URL',
  'GOOGLE_ANALYTICS_KEY',
  'GOOGLE_MAPS_KEY',
  'SETTINGS_APP_URL',
  'SENTRY_DSN',
  'RECAPTCHA_SITE_KEY',
  'AUTH_HASH',
  'USER_ID',
];

function readClientConfig() {
  if (typeof window !== 'undefined' && window.__CONFIG__) {
    return window.__CONFIG__;
  }
  return CLIENT_KEYS.reduce((acc, key) => {
    acc[key] = process.env[key];
    return acc;
  }, {});
}

const clientConfig = readClientConfig();

export { CLIENT_KEYS };

export const serverURL = clientConfig.APP_URL;
export const analyticsKey = clientConfig.GOOGLE_ANALYTICS_KEY;
export const mapsKey = clientConfig.GOOGLE_MAPS_KEY;
export const settingsAppUrl = clientConfig.SETTINGS_APP_URL;
export const recaptchaSiteKey = clientConfig.RECAPTCHA_SITE_KEY;
export const authHash = clientConfig.AUTH_HASH;
export const userId = clientConfig.USER_ID;
